/* JUVELORE FAVORI LISTESI
   - Liste ziyaretcinin tarayicisinda saklanir (localStorage, anahtar: jv:wishlist:v1). Uyelik gerekmez.
   - Kayit: urun handle'i + (urun sayfasindan kaydedildiyse) secili varyant.
   - Yer imi dugmeleri JS ile eklenir: urun kartlari (sag ust), urun sayfasi basligi, ust menu (sepetin solunda, sayacli).
   - Kaydedince panel kendiliginden acilir (LP gibi), bildirim yok.
   - Panel temanin x-drawer bileseni (sepet paneliyle ayni). Urunler sections/jv-wishlist-item ile cizilir,
     Favorilerim sayfasi sections/jv-wishlist-card ile (temanin urun karti).
   - Paneldeki "Urunu incele" temanin hizli satin al penceresini acar (olcu/renk secimi).
   - Ayrica hizli satin al penceresine masaustunde foto oklari ekler (injectQuickBuyArrows).
   - Favorilerim sayfasinda "Listeyi paylas": ?liste=handle.varyant,... baglantisi (mobilde paylas menusu, masaustunde kopyala).
     Baglantiyi acan kisi listeyi gorur, "Hepsini favorilerime ekle" ile kendi listesine alir.
   - Uyelikle hesaba kaydetme 2. asama. */
(() => {
  if (window.JVWishlist) return;

  const KEY = 'jv:wishlist:v1';
  const MAX_ITEMS = 50;
  const DRAWER_ID = 'jv-wishlist-drawer';
  const config = window.jvWishlistConfig || {};
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const TEXT = {
    title: 'Favorilerim',
    add: 'Favorilere ekle',
    remove: 'Favorilerden çıkar',
    empty: 'Favorilerinizde henüz ürün yok.',
    all: 'Tüm favorilerim',
    shared: 'Paylaşılan favoriler',
    shareTitle: 'Juvelore favorilerim',
    copied: 'Bağlantı kopyalandı'
  };

  const icon = (extraClass = '') =>
    `<svg class="jv-wl-icon ${extraClass}" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.5 3.5h11v17L12 16.2l-5.5 4.3z"/></svg>`;

  /* ---------- Kayit ---------- */

  function read() {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((item) => item && typeof item.h === 'string' && item.h) : [];
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    } catch (error) {
      /* gizli sekme vb.: liste bu oturumda tutulamaz */
    }
    onChange();
  }

  const has = (handle) => read().some((item) => item.h === handle);

  function add(handle, variant) {
    const list = read().filter((item) => item.h !== handle);
    list.unshift({ h: handle, v: variant ? Number(variant) : null, t: Date.now() });
    write(list);
  }

  function remove(handle) {
    write(read().filter((item) => item.h !== handle));
  }

  /* ---------- Dugmeler ---------- */

  function buttonHandle(button) {
    return button.dataset.handle || button.closest('product-card')?.getAttribute('handle') || '';
  }

  function buttonVariant(button) {
    if (button.dataset.context !== 'product') return null;
    const section = button.closest('.shopify-section') || document;
    const input = section.querySelector('product-form form [name="id"], form[action*="/cart/add"] [name="id"]');
    return input?.value || new URLSearchParams(location.search).get('variant');
  }

  function createButton(context, handle) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `jv-wl-btn jv-wl-btn--${context}`;
    button.dataset.jvWish = '';
    button.dataset.context = context;
    if (handle) button.dataset.handle = handle;
    button.innerHTML = icon();
    return button;
  }

  function injectCards(scope = document) {
    scope.querySelectorAll('product-card .product-card__figure').forEach((figure) => {
      if (figure.querySelector(':scope > [data-jv-wish]')) return;
      figure.appendChild(createButton('card'));
    });
  }

  function injectProduct() {
    if (!config.product) return;
    const title = document.querySelector('.product-info h1.product-title');
    const block = title?.closest('.product-info__block-item');
    if (!block || block.querySelector('[data-jv-wish]')) return;
    block.classList.add('jv-wl-has-btn');
    block.appendChild(createButton('product', config.product));
  }

  function injectHeader() {
    document.querySelectorAll('.header__secondary-nav .header__cart-link').forEach((cartItem) => {
      if (cartItem.parentElement.querySelector('.jv-wl-header')) return;
      const item = document.createElement('li');
      item.className = 'relative jv-wl-header';
      item.innerHTML = `<a href="${config.pageUrl || root + 'pages/favorilerim'}" aria-controls="${DRAWER_ID}" class="jv-wl-header__link" data-no-instant><span class="sr-only">${TEXT.title}</span>${icon('header__nav-icon')}<span class="jv-wl-count" hidden></span></a>`;
      cartItem.before(item);
    });
  }

  /* Hizli satin al penceresi: masaustunde fotografin iki yanina ok (temanin carousel dugmeleri; mobilde CSS ile gizli) */
  const arrowIcon = (path) =>
    `<svg width="12" height="22" viewBox="0 0 12 22" aria-hidden="true" focusable="false"><path d="${path}" fill="none" stroke="currentColor" stroke-width="1"/></svg>`;

  function injectQuickBuyArrows() {
    document.querySelectorAll('.quick-buy-modal product-gallery').forEach((gallery) => {
      if (gallery.querySelector('.jv-qb-arrow')) return;
      const carousel = gallery.querySelector('scroll-carousel[id]');
      const list = gallery.querySelector('.product-gallery__image-list');
      if (!carousel || !list || carousel.querySelectorAll('.product-gallery__media:not([hidden])').length < 2) return;
      list.insertAdjacentHTML('beforeend', `
        <carousel-prev-button aria-controls="${carousel.id}" class="jv-qb-arrow jv-qb-arrow--prev"><button type="button" aria-label="Önceki fotoğraf">${arrowIcon('M11 1 1 11l10 10')}</button></carousel-prev-button>
        <carousel-next-button aria-controls="${carousel.id}" class="jv-qb-arrow jv-qb-arrow--next"><button type="button" aria-label="Sonraki fotoğraf">${arrowIcon('M1 1l10 10L1 21')}</button></carousel-next-button>`);
    });
  }

  function sync() {
    const list = read();
    const saved = new Set(list.map((item) => item.h));

    document.querySelectorAll('[data-jv-wish]').forEach((button) => {
      const isSaved = saved.has(buttonHandle(button));
      button.classList.toggle('is-saved', isSaved);
      button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      button.setAttribute('aria-label', isSaved ? TEXT.remove : TEXT.add);
    });

    /* sadece degistiyse yaz: MutationObserver dongusune girmesin */
    document.querySelectorAll('.jv-wl-count').forEach((count) => {
      if (count.textContent !== String(list.length)) count.textContent = list.length;
      if (count.hidden !== (list.length === 0)) count.hidden = list.length === 0;
    });
  }

  /* ---------- Urunleri getirme (son bakilan urunler gibi, section rendering) ---------- */

  const cache = new Map();

  function fetchEntry(item, section) {
    const key = `${section}|${item.h}|${item.v || ''}`;
    if (!cache.has(key)) {
      const url = `${root}products/${encodeURIComponent(item.h)}?section_id=${section}${item.v ? `&variant=${item.v}` : ''}`;
      cache.set(key, fetch(url)
        .then((response) => (response.ok ? response.text() : ''))
        .then((html) => (html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-jv-wl-entry]') : null))
        .catch(() => null));
    }
    return cache.get(key).then((entry) => (entry ? document.importNode(entry, true) : null));
  }

  async function renderList(container, section, list = read()) {
    const token = (container.jvToken || 0) + 1;
    container.jvToken = token;
    const entries = (await Promise.all(list.map((item) => fetchEntry(item, section)))).filter(Boolean);
    if (container.jvToken !== token) return null;
    container.replaceChildren(...entries);
    return entries.length;
  }

  /* ---------- Panel ---------- */

  function ensureDrawer() {
    let drawer = document.getElementById(DRAWER_ID);
    if (drawer) return drawer;
    drawer = document.createElement('x-drawer');
    drawer.id = DRAWER_ID;
    drawer.className = `drawer jv-wl-drawer color-scheme color-scheme--${config.scheme || 'scheme-1'}`;
    drawer.setAttribute('initial-focus', 'false');
    drawer.innerHTML = `
      <p class="h4" slot="header">${TEXT.title}</p>
      <div class="jv-wl-drawer__list" data-jv-wl-list></div>
      <p class="jv-wl-empty" data-jv-wl-empty hidden>${TEXT.empty}</p>
      <div slot="footer" class="jv-wl-drawer__footer" data-jv-wl-footer hidden>
        <a href="${config.pageUrl || root + 'pages/favorilerim'}" class="button jv-wl-drawer__button">${TEXT.all}</a>
      </div>`;
    document.body.appendChild(drawer);
    return drawer;
  }

  async function renderDrawer() {
    const drawer = ensureDrawer();
    const container = drawer.querySelector('[data-jv-wl-list]');
    const count = await renderList(container, 'jv-wishlist-item');
    if (count === null) return;
    drawer.querySelector('[data-jv-wl-empty]').hidden = count > 0;
    drawer.querySelector('[data-jv-wl-footer]').hidden = count === 0;
    drawer.classList.toggle('drawer--center-body', count === 0);
  }

  function openDrawer() {
    const drawer = ensureDrawer();
    renderDrawer();
    drawer.show();
  }

  /* ---------- Favorilerim sayfasi ---------- */

  class WishlistPage extends HTMLElement {
    connectedCallback() {
      this.render();
    }

    async render() {
      const shared = sharedList();
      const count = await renderList(this, 'jv-wishlist-card', shared || read());
      if (count === null) return;
      const page = this.parentElement;
      if (!page) return;
      const empty = page.querySelector('[data-jv-wl-page-empty]');
      if (empty) empty.hidden = count > 0;
      const bar = page.querySelector('[data-jv-wl-page-bar]');
      if (bar) bar.hidden = Boolean(shared) || count === 0;
      const counter = page.querySelector('[data-jv-wl-page-count]');
      if (counter) counter.innerHTML = `Favorilerinizde <span class="jv-wl-page__num">${count} ürün</span> var`;
      const sharedBox = page.querySelector('[data-jv-wl-shared]');
      if (sharedBox) sharedBox.hidden = !shared || count === 0;
      const title = page.querySelector('[data-jv-wl-page-title]');
      if (title && shared) title.textContent = TEXT.shared;
      injectCards(this);
      sync();
    }
  }

  /* ---------- Listeyi paylas ---------- */

  const SHARE_PARAM = 'liste';
  const HANDLE_RE = /^[\p{L}\p{N}_-]+$/u;

  /* Baglantidaki liste: "handle" veya "handle.varyant", virgulle ayrilmis */
  function sharedList() {
    const value = new URLSearchParams(location.search).get(SHARE_PARAM);
    if (value === null) return null;
    const seen = new Set();
    return value.split(',').map((part) => {
      const [h, v] = part.trim().split('.');
      return { h, v: /^\d+$/.test(v || '') ? Number(v) : null };
    }).filter((item) => {
      if (!item.h || !HANDLE_RE.test(item.h) || seen.has(item.h)) return false;
      seen.add(item.h);
      return true;
    }).slice(0, MAX_ITEMS);
  }

  function shareUrl() {
    const items = read().map((item) => (item.v ? `${item.h}.${item.v}` : item.h)).join(',');
    return `${location.origin}${location.pathname}?${SHARE_PARAM}=${items}`;
  }

  async function shareList(button) {
    const url = shareUrl();
    const status = button.parentElement?.querySelector('[data-jv-wl-share-status]');
    const touch = window.matchMedia('(hover: none)').matches;
    if (touch && navigator.share) {
      try {
        await navigator.share({ title: TEXT.shareTitle, url });
      } catch (error) {
        /* kullanici paylasimi kapatti */
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      if (status) {
        status.textContent = TEXT.copied;
        clearTimeout(status.jvTimer);
        status.jvTimer = setTimeout(() => { status.textContent = ''; }, 2500);
      }
    } catch (error) {
      window.prompt(TEXT.shareTitle, url);
    }
  }

  function importShared() {
    const shared = sharedList() || [];
    const own = read();
    const handles = new Set(own.map((item) => item.h));
    const now = Date.now();
    const added = shared.filter((item) => !handles.has(item.h)).map((item, index) => ({ h: item.h, v: item.v, t: now - index }));
    try {
      localStorage.setItem(KEY, JSON.stringify([...added, ...own].slice(0, MAX_ITEMS)));
    } catch (error) {
      /* gizli sekme vb. */
    }
    location.href = location.pathname;
  }

  if (!window.customElements.get('jv-wishlist-page')) {
    window.customElements.define('jv-wishlist-page', WishlistPage);
  }

  /* ---------- Degisiklik ---------- */

  function onChange() {
    sync();
    const drawer = document.getElementById(DRAWER_ID);
    if (drawer?.open) renderDrawer();
    document.querySelectorAll('jv-wishlist-page').forEach((page) => page.render());
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-jv-wish]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      const handle = buttonHandle(button);
      if (!handle) return;
      /* LP gibi: eklenince panel kendiliginden acilir, bildirim yok */
      if (has(handle)) {
        remove(handle);
      } else {
        add(handle, buttonVariant(button));
        openDrawer();
      }
      return;
    }

    const shareButton = event.target.closest('[data-jv-wl-share]');
    if (shareButton) {
      shareList(shareButton);
      return;
    }

    if (event.target.closest('[data-jv-wl-import]')) {
      importShared();
      return;
    }

    const removeButton = event.target.closest('[data-jv-wl-remove]');
    if (removeButton) {
      const handle = removeButton.closest('[data-jv-wl-entry]')?.dataset.handle;
      if (handle) remove(handle);
      return;
    }

    if (event.target.closest(`[aria-controls="${DRAWER_ID}"]`)) {
      event.preventDefault();
      renderDrawer();
    }
  }, true);

  /* Bagli renk (linked swatch) karttaki urunu degistirir: dugme durumunu yenile */
  document.addEventListener('change', (event) => {
    if (event.target.closest?.('product-card')) setTimeout(sync, 0);
  });

  window.addEventListener('storage', (event) => {
    if (event.key === KEY) onChange();
  });

  function init() {
    ensureDrawer();
    injectHeader();
    injectCards();
    injectProduct();
    sync();
  }

  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      injectHeader();
      injectCards();
      injectProduct();
      injectQuickBuyArrows();
      sync();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.JVWishlist = { read, add, remove, has, sync, open: openDrawer };
})();
